import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import {inspection as endpoint} from '@/configs/endpoints'


export default {
  state: () => ({
    isLoad: false
  }),
  actions: {
    async connectEquipmentMeasurementForSelectedSmoke (context, data) {
      const response = await api.post(endpoint.zigBeeEquipment(data.params), {body: data.body})
      if (await requestValidation(response)) {
        return response
      } else {
        if (response?.code === 400)
          context.dispatch('getEquipmentsList', { type_inspection: 'smoke' })
        return false
      }
    },
    async startMeasurementForSelectedSmoke (context, params) {
      const response = await api.post(endpoint.startMeasurementForZigBeeEquipment(params))
      if (await requestValidation(response)) {
        return response
      }
    },
    async updateSmokeMeasurement (context, data) {
      const response = await api.patch(endpoint.updateSmoke(data.params), { body: data.body })
      return await requestValidation(response)
    },
    // async getResultMeasurementForSelectedSmoke (context, data) {
    //   const params = {
    //     id: data.id,
    //     number: data.number,
    //     type: 'smoke',
    //   }
    //   const response = await api.get(endpoint.zegbeeEquipment(params))

    //   if (await requestValidation(response)) {
    //     return response.data
    //   }
    // }
  }
}
